import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HSpecColumnList = _resolveComponent("HSpecColumnList")!
  const _component_HContainer = _resolveComponent("HContainer")!

  return (_openBlock(), _createBlock(_component_HContainer, null, {
    content: _withCtx(() => [
      _createVNode(_component_HSpecColumnList, {
        "redemption-type": _ctx.redemptionType,
        "list-item": _ctx.giftCodeDetails
      }, null, 8, ["redemption-type", "list-item"])
    ]),
    _: 1
  }))
}